import React from 'react'

const Premium = () => {
  return (
    <>
      <div className="w-[1240px] h-[694px] ml-[59px] rounded-[20px] gap-[40px] p-[40px]  shadow-xl">
        <div className="w-[1160px] h-[178px] gap-[20px]  mb-[40px]">
          <div className="w-[1160px] h-[36px] font-semibold text-[28px]">
            Premium upgrade
          </div>
          <p className="w-[1160px] h-[52px] font-normal text-[18px] mt-4">
            Would you like the Premium Upgrade? It consists of professional
            photography (10 photos), property particulars, floor plan and a
            video walkthrough. This package is designed to give your sale the
            ultimate boost.
          </p>
          <div className="w-[1160px] h-[50px] gap-[20px] grid grid-cols-2 mt-3 ">
            <div className="w-[570px] h-[50px] rounded-xl bg-white border border-[#FFEBB0] py-3 px-4 gap-[10px] flex items-center text-[#A6A7A8]">
              <div className="h-[24px] w-[24px]">
                <input
                  type="radio"
                  className="h-[17px] w-[17px] mt-1 border border-[#A6A7A8]"
                />
              </div>
              <div className="w-[437px] h-[26px] font-normal text-[18px] ">
                Yes, please I would like that
              </div>
              <div className="w-[57px] h-[26px]">£10.00</div>
            </div>
            <div className="w-[570px] h-[50px] rounded-xl bg-white border border-[#FFEBB0] py-3 px-4 gap-[10px] flex items-center text-[#A6A7A8]">
              <div className="h-[24px] w-[24px]">
                <input
                  type="radio"
                  className="h-[17px] w-[17px] mt-1 border border-[#A6A7A8]"
                />
              </div>
              <div className="w-[437px] h-[26px] font-normal text-[18px] ">
                No thanks, I’ll stick with the standard listing
              </div>
              <div className="w-[57px] h-[26px]">Free</div>
            </div>
          </div>
        </div>

        <div className="w-[1160px] h-[178px] gap-[20px] mb-[40px]">
          <div className="w-[1160px] h-[36px] font-semibold text-[28px]">
            Premium listing on Right move
          </div>
          <p className="w-[1160px] h-[52px] font-normal text-[18px] mt-4">
            Would you like your property to be listed on Right move? On Right
            move, premium listing properties get 50% more views than standard
            listings, making them stand out from similar standard properties.
          </p>
          <div className="w-[1160px] h-[50px] gap-[20px] grid grid-cols-2 mt-3 ">
            <div className="w-[570px] h-[50px] rounded-xl bg-white border border-[#FFEBB0] py-3 px-4 gap-[10px] flex items-center text-[#A6A7A8]">
              <div className="h-[24px] w-[24px]">
                <input
                  type="radio"
                  className="h-[17px] w-[17px] mt-1 border border-[#A6A7A8]"
                />
              </div>
              <div className="w-[437px] h-[26px] font-normal text-[18px] ">
                Yes, please I would like that
              </div>
              <div className="w-[57px] h-[26px]">£10.00</div>
            </div>
            <div className="w-[570px] h-[50px] rounded-xl bg-white border border-[#FFEBB0] py-3 px-4 gap-[10px] flex items-center text-[#A6A7A8]">
              <div className="h-[24px] w-[24px]">
                <input
                  type="radio"
                  className="h-[17px] w-[17px] mt-1 border border-[#A6A7A8]"
                />
              </div>
              <div className="w-[437px] h-[26px] font-normal text-[18px] ">
                No thanks, I’ll stick with the standard listing
              </div>
              <div className="w-[57px] h-[26px]">Free</div>
            </div>
          </div>
        </div>

        <div className="w-[1160px] h-[178px] gap-[20px] mb-[40px]">
          <div className="w-[343px] h-[36px] font-semibold text-[28px]">
            Premium listing on Zoopla
          </div>
          <p className="w-[1160px] h-[52px] font-normal text-[18px] mt-4">
            Would you like your property to be listed on Zoopla? On Right move,
            premium listing properties get 50% more views than standard
            listings, making them stand out from similar standard properties.
          </p>
          <div className="w-[1160px] h-[50px] gap-[20px] grid grid-cols-2 mt-3 ">
            <div className="w-[570px] h-[50px] rounded-xl bg-white border border-[#FFEBB0] py-3 px-4 gap-[10px] flex items-center text-[#A6A7A8]">
              <div className="h-[24px] w-[24px]">
                <input
                  type="radio"
                  className="h-[17px] w-[17px] mt-1 border border-[#A6A7A8]"
                />
              </div>
              <div className="w-[437px] h-[26px] font-normal text-[18px] ">
                Yes, please I would like that
              </div>
              <div className="w-[57px] h-[26px]">£10.00</div>
            </div>
            <div className="w-[570px] h-[50px] rounded-xl bg-white border border-[#FFEBB0] py-3 px-4 gap-[10px] flex items-center text-[#A6A7A8]">
              <div className="h-[24px] w-[24px]">
                <input
                  type="radio"
                  className="h-[17px] w-[17px] mt-1 border border-[#A6A7A8]"
                />
              </div>
              <div className="w-[437px] h-[26px] font-normal text-[18px] ">
                No thanks, I’ll stick with the standard listing
              </div>
              <div className="w-[57px] h-[26px]">Free</div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-[1240px] h-[328px] gap-[30px] ml-[59px] grid grid-cols-2 mt-[40px]">
        <div className="w-[605px] h-[328px] rounded-[12px] p-[40px] ga-[40px] shadow-xl">
          <div className="w-[525px] h-[248px] gap-[20px]">
            <p className="w-[525px] h-[36px] text-[28px] font-semibold">
              Energy Performance Certificate
            </p>
            <p className="w-[525px] h-[52px] text-lg font-normal mt-5">
              Energy Performance Certificate is required for property sale; we
              can provide if needed or outdated.
            </p>
            <div className="w-[525px] h-[50px] rounded-xl bg-white border border-[#FFEBB0] py-3 px-4 gap-[10px] flex items-center text-[#A6A7A8] mt-5">
              <div className="h-[24px] w-[24px]">
                <input
                  type="radio"
                  className="h-[17px] w-[17px] mt-1 border border-[#A6A7A8]"
                />
              </div>
              <div className="w-[437px] h-[26px] font-normal text-[18px] ">
                Yes, please I would like that
              </div>
              <div className="w-[57px] h-[26px]">£10.00</div>
            </div>
            <div className="w-[525px] h-[50px] rounded-xl bg-white border border-[#FFEBB0] py-3 px-4 gap-[10px] flex items-center text-[#A6A7A8] mt-5">
              <div className="h-[24px] w-[24px]">
                <input
                  type="radio"
                  className="h-[17px] w-[17px] mt-1 border border-[#A6A7A8]"
                />
              </div>
              <div className="w-[437px] h-[26px] font-normal text-[18px] ">
                No thanks, I’ll upload my own
              </div>
              <div className="w-[57px] h-[26px]">Free</div>
            </div>
          </div>
        </div>

        <div className="w-[605px] h-[328px] rounded-[12px] p-[40px] ga-[40px] shadow-xl">
          <div className="w-[525px] h-[248px] gap-[20px]">
            <p className="w-[525px] h-[36px] text-[28px] font-semibold">
              Gas Performance Certificate
            </p>
            <p className="w-[525px] h-[52px] text-lg font-normal mt-5">
              Gas Performance Certificate is required for property sale; we can
              provide if needed or outdated.
            </p>
            <div className="w-[525px] h-[50px] rounded-xl bg-white border border-[#FFEBB0] py-3 px-4 gap-[10px] flex items-center text-[#A6A7A8] mt-5">
              <div className="h-[24px] w-[24px]">
                <input
                  type="radio"
                  className="h-[17px] w-[17px] mt-1 border border-[#A6A7A8]"
                />
              </div>
              <div className="w-[437px] h-[26px] font-normal text-[18px] ">
                Yes, please I would like that
              </div>
              <div className="w-[57px] h-[26px]">£10.00</div>
            </div>
            <div className="w-[525px] h-[50px] rounded-xl bg-white border border-[#FFEBB0] py-3 px-4 gap-[10px] flex items-center text-[#A6A7A8] mt-5">
              <div className="h-[24px] w-[24px]">
                <input
                  type="radio"
                  className="h-[17px] w-[17px] mt-1 border border-[#A6A7A8]"
                />
              </div>
              <div className="w-[437px] h-[26px] font-normal text-[18px] ">
                No thanks, I’ll upload my own
              </div>
              <div className="w-[57px] h-[26px]">Free</div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-[1240px] h-[50px] gap-[8px] mt-[40px] flex justify-end mb-[150px] ml-[59px]">
        <button
          className={`flex items-center bg-[#E8AE00] rounded-xl py-3 px-4  w-[104px] h-[50px] gap-[8px]`}
        >
          <div className="h-[24px] w-[24px]">
            <svg
              width="9"
              height="16"
              viewBox="0 0 9 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mt-[4px]"
            >
              <path
                d="M7.99978 15.7508C7.80778 15.7508 7.61575 15.6778 7.46975 15.5308L0.46975 8.53079C0.17675 8.23779 0.17675 7.76275 0.46975 7.46975L7.46975 0.46975C7.76275 0.17675 8.23779 0.17675 8.53079 0.46975C8.82379 0.76275 8.82379 1.23779 8.53079 1.53079L2.06081 8.00076L8.53079 14.4707C8.82379 14.7637 8.82379 15.2388 8.53079 15.5318C8.38379 15.6778 8.19178 15.7508 7.99978 15.7508Z"
                fill="#0D0E0F"
              />
            </svg>
          </div>
          <p className="w-[74px] h-[26px] font-[500] text-lg flex items-center">
            Back
          </p>
        </button>
        <button
          className={`flex items-center bg-[#E8AE00] rounded-xl py-3 px-4  w-[138px] h-[50px] opacity-[20%] gap-[8px]`}
        >
          <p className="w-[74px] h-[26px] font-[500] text-lg flex items-center">
            Continue
          </p>
          <div className="h-[24px] w-[24px]">
            <svg
              width="9"
              height="16"
              viewBox="0 0 9 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mt-[4px] ml-[8px]"
            >
              <path
                d="M0.999779 15.7498C0.807779 15.7498 0.61575 15.6768 0.46975 15.5298C0.17675 15.2368 0.17675 14.7618 0.46975 14.4688L6.93972 7.9988L0.46975 1.52883C0.17675 1.23583 0.17675 0.760797 0.46975 0.467797C0.76275 0.174797 1.23779 0.174797 1.53079 0.467797L8.53079 7.4678C8.82379 7.7608 8.82379 8.23583 8.53079 8.52883L1.53079 15.5288C1.38379 15.6768 1.19178 15.7498 0.999779 15.7498Z"
                fill="#0D0E0F"
              />
            </svg>
          </div>
        </button>
      </div>
    </>
  );
}

export default Premium